import Axios from 'axios'

// Add Axios interceptor globally to remove trailing slashes
Axios.interceptors.request.use(
  config => {
    if (config.url && typeof config.url === 'string') {
      config.url = config.url.replace(/\/+$/, '') // Remove trailing slashes
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default Axios // Export the global Axios instance
